export default __webpack_public_path__ + "static/02-buyer-fabrics-products-tab-11e8d96dfb88c56f9d6e3777d2151fd1.png";